
export default {
  name: "cal-star-reviews-section",
  data() {
    return {
      numberOfStars: 5,
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    colour: {
      type: String,
      default: "text-primary",
    },
    starSize: {
      type: String,
      default: "w-[1.5rem] sm:w-[1.5rem]",
    },
    hideRating: {
      type: Boolean,
      default: false,
    },
    rating: {
      type: Number,
      default: 5,
    },
  },
  computed:{
    starRating() {
      return this.rating ? this.rating : 5;
    },
  },
  methods: {
    getStarStyle(index) {
      const rating = this.rating ? this.rating : 5;
      const starValue = index - 1;
      const fill = Math.min(Math.max((rating - starValue) * 100, 0), 100);

      return {
        background: `linear-gradient(90deg, #0A9EA5 ${fill}%, #e5e5e5 ${fill}%)`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        display: "inline-block",
      };
    },
    scrollToDiv() {
      // Get the target div by ID
      const targetDiv = document.getElementById(this.id);

      // Check if the target div exists
      if (targetDiv) {
        // Use the smooth scroll behavior
        targetDiv.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
